import {
  laptopMax,
  laptopMaxXL,
  laptopMediumMax,
  laptopMediumMin,
  mobileLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import DevBox from '@propertypal/shared/src/resources/images/development-microsites/dev-box.png';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import { Content as PageWrapper } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled from 'styled-components';

const PADDING_MOB = 80;

export const Container = styled.div`
  background: ${({ theme }) => theme.backgroundLightest};
  width: 100%;

  ${PageWrapper} {
    position: relative;
    padding: 150px 30px 120px 30px;

    @media (${laptopMediumMax}) {
      padding: ${PADDING_MOB}px 15px;
    }
  }
`;

export const ContentText = styled.div`
  width: 100%;
  max-width: 640px;

  ${SubHeading} {
    color: ${({ theme }) => theme.textDark};
    line-height: 1.1;

    span {
      color: ${({ theme }) => theme.primary};
    }

    @media (${laptopMax}) {
      font-size: 50px;
    }

    @media (${mobileLargeMax}) {
      font-size: 40px;
    }
  }

  ${Text} {
    line-height: 1.42;
    max-width: 580px;
  }

  @media (${laptopMediumMax}) {
    margin: 0 auto;
    text-align: center;

    ${Button} {
      margin: 0 auto;
    }

    ${Text} {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const BespokeDesignImage = styled.div`
  @media (${laptopMediumMin}) {
    position: absolute;
    bottom: 0;
    right: 0;
    background-image: url(${DevBox.src});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    height: 800px;
    width: 750px;
  }

  @media (${laptopMaxXL}) {
    height: 710px;
    width: 440px;
  }

  @media (${laptopMediumMax}) {
    position: relative;
    width: 100%;
    height: 420px;

    &:after {
      content: '';
      position: absolute;
      bottom: -${PADDING_MOB}px;
      right: 0;
      background-image: url(${DevBox.src});
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      height: 500px;
    }
  }

  @media (${mobileLargeMax}) {
    height: 300px;

    &:after {
      height: 300px;
    }
  }
`;
